export default __webpack_public_path__ + "static/media/Receipt.0ebf416e.svg";